<template>
    <el-row style="margin:5px;">
        <el-col :xs="24" :sm="13" :md="12" :lg="11" :xl="10" class="tw-tablet-user">
            <div style="background-color:white;">
                <el-table ref="refUserTable" style="width:100%;" border
                    :data="userData" highlight-current-row @current-change="onCurrentChange"
                    :header-cell-style="{ background: '#fafafa' }">
                    <el-table-column type="index" width="35"></el-table-column>
                    <el-table-column prop="phone" label="手机号码"></el-table-column>
                    <el-table-column prop="user_name" label="姓名"></el-table-column>
                    <el-table-column prop="user_type" label="类型">
                        <template #default="scope">
                            <span>{{ getUserTypeName(scope.row.user_type) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="120">
                        <template #default="scope">
                            <el-button @click="onEdit(scope.$index, scope.row)" type="text">编辑</el-button>
                            <el-button @click="onDelete(scope.$index, scope.row)" type="text">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-button icon="el-icon-circle-plus" style="margin:10px" @click="onAdd()" type="text">新增用户</el-button>
            </div>
        </el-col>
        <el-col :xs="24" :sm="11" :md="12" :lg="13" :xl="14" class="tw-tablet-power">
            <el-table ref="refPowerTable" :data="powerData" border style="width: 100%" row-key="id"
                :row-class-name="getRowClassName"
                :header-row-class-name="getHeaderRowClassName"
                :header-cell-style="{ background: '#fafafa' }"
                @select="onSelect"
                @select-all="onSelectAll">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="label" label="菜单" width="380"></el-table-column>
                <el-table-column prop="remark" label="说明"></el-table-column>
            </el-table>
        </el-col>
    </el-row>

    <!-- 用户对话框 -->
    <el-dialog :title="userModel.index === -1 ? '新增用户' : `编辑用户 - ${userData[userModel.index]?.user_name}`" v-model="dialogVisible">
        <el-form ref="refForm" :model="userModel" :rules="rules" label-position="top" size="mini" label-width="80px">
            <el-form-item label="手机号码" prop="phone" >
                <el-input :disabled="userModel.index !== -1" style="width:250px" v-model="userModel.phone"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="user_name">
                <el-input :disabled="userModel.index !== -1" style="width:250px" v-model="userModel.user_name"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="user_type">
                <el-radio-group v-model="userModel.user_type">
                    <el-radio v-for="userType in canAllowUserTypes" :key="userType.no" :label="userType.no">{{userType.name}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input type="textarea" :rows="5" v-model="userModel.remark"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="onConfirm">确 定</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ref, reactive, onMounted, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

// import systemService from '../../services/system.service'
import httpService from '../../services/http.service'
import userService from '../../services/user.service'
import 'element-plus/theme-chalk/display.css';

export default {
    name: 'tw-tablet-user',
    setup() {
        const route = useRoute()

        const sobNo = computed(() => {
            return route.query.sob_no
        })
        watch(sobNo, () => {
            if (route.name === 'user') {
                loadData()
            }
        })

        const userData = ref([])
        const refUserTable = ref(null)

        const powerData = ref([])
        const refPowerTable = ref(null)

        let selectItems = new WeakMap()
        const currentRow = ref(null)

        const dialogVisible = ref(false)
        const userModel = reactive({
            index: -1,  // -1 时新增，其余为编辑
            phone: '',
            user_name: '',
            user_type: 'user',
            remark: '' 
        })

        const refForm = ref(null)
        const rules = {
            phone: [{ required: true, message: '请输入账号', trigger: 'blur' }],
            user_name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
        }

        const userTypes = [
            { no: 'user', name: '普通用户' },
            { no: 'admin', name: '管理员' },
            { no: 'root', name: '超级管理员' }
        ]

        const canAllowUserTypes = [
            { no: 'user', name: '普通用户' }
        ]

        const userType = userService?.user?.user_type ?? 'user'
        switch (userType) {
            case 'root':
                canAllowUserTypes.push({ no: 'admin', name: '管理员' }, { no: 'root', name: '超级管理员' })
                break;
            case 'admin':
                canAllowUserTypes.push({ no: 'admin', name: '管理员' })
                break;
            default:
                break;
        }

        // userData.value = [
        //     { phone: '13751388444', user_name: '陈佳威', user_type: 'root' },
        //     { phone: '13790668651', user_name: '叶伟坚', user_type: 'user' }
        // ]

        // powerData.value = [
        //     { item_no: 'sample', item_name: '开发打样', remark: '' },
        //     { item_no: 'sales-query', item_name: '销售查询', remark: '' },
        //     { item_no: 'supply-query', item_name: '供应查询', remark: '' },
        // ]

        // 将查询参数加入账套号（如果路由中存在账套参数的话，root用户有权限设置所有账套的用户，会在url中带上 ?sob_no=xxxx）
        const setSobNo = function(params) {
            if (route.query.sob_no) {
                params['sob_no'] = route.query.sob_no
            }
        }

        // 添加新用户
        const onAdd = function() {
            Object.assign(userModel, { index: -1, phone: '', user_name: '', user_type: 'user', remark: '' })
            dialogVisible.value = true
        }

        // 编辑用户
        const onEdit = function(index, row) {
            if (userService?.user?.sob_no === route.query.sob_no && userService?.user?.user_id === row.user_id) {
                ElMessage.info({
                    showClose: true,
                    message: '不允许编辑当前登录用户'
                })
                return
            }

            if (canAllowUserTypes.find(el => el.no === row.user_type)) {
                Object.assign(userModel, { index: index }, JSON.parse(JSON.stringify(row)))
                dialogVisible.value = true
            } else {
                ElMessage.info({
                    showClose: true,
                    message: `无权限编辑该用户`
                })
            }
        }

        // 删除用户
        const onDelete = function(index, row) {
            if (userService?.user?.sob_no === route.query.sob_no && userService?.user?.user_id === row.user_id) {
                ElMessage.info({
                    showClose: true,
                    message: '不允许删除当前登录用户'
                })
                return
            }

            if (canAllowUserTypes.find(el => el.no === row.user_type)) {
                ElMessageBox.confirm(`确定要删除【${row.user_name}】这个用户吗？`, '提示信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const params = { /* project_id: systemService.project_id, */ user_id: row.user_id }
                    setSobNo(params)
                    httpService.delete('admin-user', params).then(() => {
                        userData.value.splice(index, 1)
                        if (index < (userData.value.length - 1)) {
                            refUserTable.value.setCurrentRow(userData.value[index])
                        } else {
                            refUserTable.value.setCurrentRow(userData.value[userData.value.length - 1])
                        }
                    }).catch(err => {
                        ElMessage.info({
                            showClose: true,
                            message: err.message
                        })
                    })
                }).catch(() => {

                })
            } else {
                ElMessage.info({
                    showClose: true,
                    message: `无权限删除该用户`
                })
            }
        }

        const onConfirm = function() {
            refForm.value.validate((valid) => {
                if (valid) {
                    const user = userData.value.find((el, index) => el.phone === userModel.phone && index !== userModel.index)
                    if (!user) {
                        const newUser = {
                            phone: userModel.phone,
                            user_name: userModel.user_name,
                            user_type: userModel.user_type,
                            remark: userModel.remark
                        }

                        if (userModel.index === -1) {
                            const params = { /* project_id: systemService.project_id */ }
                            setSobNo(params)
                            httpService.post('admin-users', params, newUser).then(result => {
                                userData.value.push(result)
                                refUserTable.value.setCurrentRow(userData.value[userData.value.length - 1])
                                dialogVisible.value = false
                            }).catch(err => {
                                ElMessage.info({
                                    showClose: true,
                                    message: err.message
                                })
                            })
                        } else {
                            const params = { /* project_id: systemService.project_id, */ user_id: userModel.user_id }
                            setSobNo(params)
                            httpService.put('admin-user', params, newUser).then(result => {
                                userData.value[userModel.index] = result
                                refUserTable.value.setCurrentRow(userData.value[userModel.index])
                                dialogVisible.value = false
                            }).catch(err => {
                                ElMessage.info({
                                    showClose: true,
                                    message: err.message
                                })
                            })
                        }
                    } else {
                        ElMessage.info({
                            showClose: true,
                            message: `手机号码 ${ userModel.phone } 已存在！`
                        })
                    }
                }
            })
        }

        const onCurrentChange = function(value) {
            currentRow.value = value

            // 清除上一用户勾选项目
            selectItems = new WeakMap()
            refPowerTable.value.clearSelection()
            // 加载当前用户权限（勾选有权限的项目）
            if (value) {
                const params = { /* project_id: systemService.project_id, */ user_id: value.user_id }
                setSobNo(params)
                httpService.get('admin-user-powers', params).then(userPowers => {
                    const setSelectItems = function(items, powers) {
                        let selectCount = 0
                        for (let i = 0; i < items.length; i++) {
                            const item = items[i]
                            
                            let power = false
                            if (item.type === 'folder') {
                                // 文件夹下有项目且有权限时才要，否则连文件夹一起删除
                                if (item?.children?.length) {
                                    const isSelect = setSelectItems(item.children, powers)
                                    // 为 true 和 空字符 时为选中状态，否则为 false
                                    refPowerTable.value.toggleRowSelection(item, isSelect === false ? false : true)    
                                    selectItems.set(item, isSelect)
                                }
                            } else {
                                power = !!powers.find(el => el === item.id)
                                if (power) {
                                    selectCount++
                                    selectItems.set(item, true)
                                    refPowerTable.value.toggleRowSelection(item, true)
                                }
                            }
                        }

                        let isSelect = items.length === selectCount
                        if (!isSelect) {
                            if (selectCount === 0) {
                                isSelect = false
                            } else {
                                isSelect = ''
                            }
                        }

                        return isSelect
                    }

                    setSelectItems(powerData.value, userPowers)
                }).catch(err => {
                    ElMessage.info({
                        showClose: true,
                        message: err.message
                    })
                })
            }
        }

        const getRowClassName = function({ row }) {
            const isSelect = selectItems.get(row)
            if (isSelect === "") {
                return "indeterminate"
            }
        }

        const getHeaderRowClassName = function() {
            let oneProductIsSelect = []
            powerData.value.forEach(item => {
                oneProductIsSelect.push(selectItems.get(item))
            })
            if (oneProductIsSelect.includes("")) {
                return "indeterminate"
            }
            return ""
        }

        const loadData = function() {
            const params = { /* project_id: systemService.project_id */ sob_no: userService.user.sob_no }
            setSobNo(params)
            httpService.get('admin-sob-items', params).then(powers => {
                // 初始化菜单
                // 1、删除无权限的节点
                // 2、给子节点设置父节点，方便勾选权限时查找父节点
                const initMenus = function(items, powers, parent) {
                    const delItems = []
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i]
                        // 设置父节点
                        item.parent = parent

                        let power = false
                        if (item.type === 'folder') {
                            // 文件夹下有项目且有权限时才要，否则连文件夹一起删除
                            if (item?.children?.length) {
                                initMenus(item.children, powers, item)
                                power = item.children.length > 0
                            }
                        } else {
                            power = !!powers.find(el => el === item.id)
                        }
                        
                        if (!power) {
                            delItems.push(item)
                        }
                    }

                    delItems.forEach(el => {
                        const index = items.findIndex(item => item === el)
                        if (index !== -1) {
                            items.splice(index, 1)
                        }
                    })
                }

                const menus = require('/public/static/menus.json')
                // 需要深复制，否则 initMenus 会修改到原始数据
                const items = JSON.parse(JSON.stringify(menus))
                initMenus(items, powers)
                powerData.value = items

                // 需要加载完权限项才可以开始加载用户数据，因为需要勾选当前活动用户的权限项
                httpService.get('admin-users', params).then(result => {
                    userData.value = result
                    if (userData.value.length) {
                        refUserTable.value.setCurrentRow(userData.value[0])
                    }
                }).catch(err => {
                    ElMessage.info({
                        showClose: true,
                        message: err.message
                    })
                })
            }).catch(err => {
                ElMessage.info({
                    showClose: true,
                    message: err.message
                })
            })
        }

        const saveData = function() {
            if (currentRow.value) {
                const getSelectMenuIds = function(items) {
                    const result = []
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        if (item.type === 'folder') {
                            const subResult = getSelectMenuIds(item.children)
                            result.push(...subResult)
                        } else {
                            const isSelect = selectItems.get(item)
                            if (isSelect && (item.type === 'page' || item.type === 'link')) {
                                result.push(item.id)
                            }
                        }
                    }
                    return result
                }

                const params = { /* project_id: systemService.project_id, */ user_id: currentRow.value.user_id }
                setSobNo(params)
                const data = getSelectMenuIds(powerData.value)
                httpService.put('admin-user-powers', params, data).then(() => {
                    // 保存成功
                }).catch(err => {
                    ElMessage.info({
                        showClose: true,
                        message: err.message
                    })
                })
            }
        }

        const onSelect = function(selection, row, isSave = true) {
            let isSelect = selectItems.get(row)
            //当点击父级点复选框时，当前的状态可能为未知状态，所以当前行状态设为false并选中，即可实现子级点全选效果
            if (isSelect === "") {
                isSelect = false
                refPowerTable.value.toggleRowSelection(row, true);
            }
            isSelect = !isSelect
            selectItems.set(row, isSelect)
            //判断操作的是子级点复选框还是父级点复选框，如果是父级点，则控制子级点的全选和不全选
            if (row.children && row.children.length > 0) {
                row.children.forEach(item => {
                    selectItems.set(item, isSelect)
                    refPowerTable.value.toggleRowSelection(item, isSelect);
                })
            } else {
                //操作的是子节点  1、获取父节点  2、判断子节点选中个数，如果全部选中则父节点设为选中状态，如果都不选中，则为不选中状态，如果部分选择，则设为不明确状态
                const item = row.parent    
                if (item) {
                    let isAllSelect = [];
                    item.children.forEach((childrenItem) => {
                        isAllSelect.push(selectItems.get(childrenItem) ?? false)
                    })
                    
                    if (isAllSelect.every(selectItem => selectItem === true)) {
                        // 全选中
                        selectItems.set(item, true)
                        refPowerTable.value.toggleRowSelection(item, true);
                    } else if (isAllSelect.every(selectItem => selectItem === false)) {
                        // 全未选
                        selectItems.set(item, false)
                        refPowerTable.value.toggleRowSelection(item, false);
                    } else {
                        // 不确定状态
                        selectItems.set(item, "")
                        refPowerTable.value.toggleRowSelection(item, true);
                    }
                }
            }

            if (isSave) {
                saveData()
            }
        }

        const onSelectAll = function(selection) {
            //判断一级节点是否是全选.如果全为true，则设置为取消全选，否则全选
            const selects = powerData.value.map(item => selectItems.get(item))
            const isAllSelect = selects.every(el => el === true)

            powerData.value.forEach(item => {
                selectItems.set(item, isAllSelect)
                refPowerTable.value.toggleRowSelection(item, !isAllSelect);
                onSelect(selection, item, false)
            })

            saveData()
        }

        const getUserTypeName = function(no) {
            const userType = userTypes.find(el => el.no === no)
            return userType?.name ?? ''
        }

        onMounted(() => {
            loadData()
        })
        
        return {
            // 左边用户表相关
            refUserTable, userData, userTypes, onCurrentChange, onAdd, onEdit, onDelete, getUserTypeName,
            // 右边权限表相关
            refPowerTable, powerData, onSelect, onSelectAll, getRowClassName, getHeaderRowClassName,
            // 用户编辑对话框相关
            refForm, rules, userModel, canAllowUserTypes, dialogVisible, onConfirm
        }
    }
}
</script>

<style>
@media screen and (max-width: 775px) {
    .el-dialog {
        width: calc(100% - 10px * 2) !important;
        height: calc(100vh - 10px * 2) !important;
        margin: 10px !important;
    }
    .tw-tablet-user>div {
        height: auto !important;
    }
    .tw-tablet-power {
        height: auto !important;
    }
}
.tw-tablet-user {
    padding-right: 5px;
}
.tw-tablet-user>div {
    height:calc(100vh - 70px);
}
.tw-tablet-power {
    height: calc(100vh - 70px);
    background-color: white;
}

/* 勾选框不确定状态样式 */
.indeterminate .el-checkbox__input .el-checkbox__inner::after {
  content: "";
  position: absolute;
  display: block;
  background-color: #fff;
  height: 2px;
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 5px;
  width: auto !important;
}

</style>